<template>
  <div class="product">
    <NavBer></NavBer>
    <div>
      <el-carousel height="500px" :autoplay="true" arrow="never" :interval="3000">
          <el-carousel-item v-for="(item,index) in Rotation" :key="index">
            <div class="rotationimg">
              <img :src="item.url" alt="">
            </div>
          </el-carousel-item>
        </el-carousel>
    </div>
   
    <div class="w content">
      <el-row>
        <el-col :span="8">
          <div class="grid-content">
            <img src="../assets/images/product/product1.png" alt="">
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content bgs">
            <h4 class="commodity">【钙尔奇】钙铁锌铜维生素D咀嚼片</h4>
            <hr />
            <div><span>【规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格】</span> <span>(巧克力味)160g(2g*80片)</span></div>
            <div><span>【批准文号】</span> <span>食健备 G202132000048</span></div>

            <div>
              <span>【产&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地】</span>
              <span> 惠氏制药有限公司</span>

            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="grid-content">
            <img src="../assets/images/product/product2.png" alt="">
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content bgs">
            <h4 class="commodity">【昆中药】丹栀逍遥丸</h4>
            <hr />
            <div><span>【规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格】</span> <span>6g*20袋/盒</span></div>
            <div><span>【批准文号】</span> <span>国药准字 Z53020866</span></div>

            <div>
              <span>【产&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地】</span>
              <span>昆明中药厂有限公司</span>

            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="grid-content">
            <img src="../assets/images/product/product3.png" alt="">
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content bgs">
            <h4 class="commodity">【感康】复方氨酚烷胺片</h4>
            <hr />
            <div><span>【规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格】</span> <span>12片/盒</span></div>
            <div><span>【批准文号】</span> <span>国药准字 H22026193</span></div>
            <div>
              <span>【产&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地】</span>
              <span>吉林省吴太感康药业有限公司</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="grid-content">
            <img src="../assets/images/product/product4.png" alt="">
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content bgs">
            <h4 class="commodity">【葡立】盐酸氨基葡萄糖胶囊</h4>
            <hr />
            <div><span>【规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格】</span> <span>0.24g*42粒/瓶/盒</span></div>
            <div><span>【批准文号】</span> <span>国药准字 H20173212</span></div>

            <div>
              <span>【产&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地】</span>
              <span>北京葡立药业有限公司</span>

            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="grid-content">
            <img src="../assets/images/product/product5.png" alt="">
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content bgs">
            <h4 class="commodity">【北京同仁堂】生脉饮(党参方)</h4>
            <hr />
            <div><span>【规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格】</span> <span>10ml*10支/盒</span></div>
            <div><span>【批准文号】</span> <span>国药准字 Z11020372</span></div>

            <div>
              <span>【产&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地】</span>
              <span>北京同仁堂科技发展股份有限公司制药厂</span>

            </div>
          </div>
        </el-col>
      </el-row>
      



    </div>
    <Footbar></Footbar>
  </div>
</template>

<script>
import NavBer from "../components/nav";
import Footbar from "../components/footbar";
export default {
  name: "product",
  data() {
    return {
      Rotation: [
        {
          url: require('../assets/images/product/product1.png')
        },
        {
          url: require('../assets/images/product/product2.png')
        },
        {
          url: require('../assets/images/product/product3.png')
        },
         {
          url: require('../assets/images/product/product4.png')
        },
         {
          url: require('../assets/images/product/product5.png')
        }
         
      ]
    };
  },
  components: {
    NavBer,
    Footbar,
  },
};
</script>

<style scoped>
.product {
  padding-top: 90px;
}
.el-carousel__item h3 {
  height: 500px;
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 500px;
    margin: 0;
  }
  
  .rotationimg {
    /* width: 600px; */
    /* height: 300px; */
    text-align: center;
    /* margin: 0 auto; */
    margin-top: 100px;
  }
  .rotationimg img {
    width: 500px;
    height: 400px;
    /* margin: o auto; */
  }

.bg1 {
  width: 100%;
  height: 500px;
  margin-bottom: 10px;
}

.bg1 img {
  width: 100%;
  height: 100%;
}

.content {
  margin-top: 60px;

}

.commodity {
  margin: 20px 0 10px 0;
}

.bgs {
  /* background-color: pink; */
  padding-left: 100px;
  padding-right: 100px;
}

.el-row {
  margin-bottom: 60px;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.grid-content {
  border-radius: 4px;
  height: 260px;
  /* border: solid 1px #333; */
}

.grid-content img {
  /* width: 100%; */
  height: 100%;
}
</style>
